import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromLicenseMgt from './reducers/license-mgt.reducer';
import { EffectsModule } from '@ngrx/effects';
import { LicenseMgtEffects } from './effects/license-mgt.effects';
import * as fromLicenseMgtList from './reducers/license-mgt-list.reducer';
import { LicenseMgtListEffects } from './effects/license-mgt-list.effects';
import * as fromListFilter from './reducers/license-mgt-list-filter.reducer';
import * as fromLicenseSettingList from './reducers/license-setting-list.reducer';
import * as fromLicenseSettingListFilter from './reducers/license-setting-list-filter.reducer';
import * as fromLicenseDetail from './reducers/license-detail.reducer';
import { LicenseDetailEffects } from './effects/license-detail.effects';
import * as fromTrialLicense from './reducers/trial-license.reducer';
import { TrialLicenseEffects } from './effects/trial-license.effects';
import * as fromLicenseSw from './reducers/license-sw.reducer';
import { LicenseSwEffects } from './effects/license-sw.effects';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    EffectsModule.forFeature([LicenseMgtEffects, LicenseMgtListEffects, LicenseDetailEffects, TrialLicenseEffects, LicenseSwEffects]),
    StoreModule.forFeature('licenseMgt', fromLicenseMgt.reducer),
    StoreModule.forFeature('licenseMgtList', fromLicenseMgtList.reducer),
    StoreModule.forFeature('licenseMgtListFilter', fromListFilter.reducer),
    StoreModule.forFeature('licenseSettingList', fromLicenseSettingList.reducer),
    StoreModule.forFeature('licenseSettingListFilter', fromLicenseSettingListFilter.reducer),
    StoreModule.forFeature('licenseDetail', fromLicenseDetail.reducer),
    StoreModule.forFeature('trialLicense', fromTrialLicense.reducer),
    StoreModule.forFeature('licenseSw', fromLicenseSw.reducer),
    StoreModule.forFeature('licenseSwType', fromLicenseSw.TypeReducer)
  ]
})
export class LicenseMgtModule { }
